// src/constants/defaultContractText.js

const defaultContractText = `
ONLINE TAHSİLAT SÖZLEŞMESİ

Madde 1 – Taraflar

İşbu sözleşme, bir tarafta ödeme tahsil eden gerçek veya tüzel kişi (bundan sonra “Alacaklı Taraf” olarak anılacaktır) ile diğer tarafta elektronik ortamda ödeme yapan gerçek veya tüzel kişi (bundan sonra “Borçlu Taraf” olarak anılacaktır) arasında, sistem sağlayıcısı tarafından sunulan online tahsilat altyapısı üzerinden gerçekleştirilen ödeme işlemine ilişkin koşulları düzenlemek amacıyla akdedilmiştir.

Sistem altyapısı sağlayıcısı (“Sistem Sağlayıcı”), yalnızca teknik altyapıyı sunmakta olup işbu sözleşmenin tarafı değildir.


Madde 2 – Konu ve Kapsam

Bu sözleşmenin konusu, Borçlu Taraf tarafından Alacaklı Taraf’a yapılacak elektronik tahsilat işleminin usul ve esaslarının belirlenmesidir.

Taraflar, bu işlemin bir borç ifası niteliğinde olduğunu, Alacaklı Taraf’ın alacağını sistem aracılığıyla tahsil edeceğini, Borçlu Taraf’ın ise borcunu elektronik ortamda ifa edeceğini kabul eder.
Sistem Sağlayıcı yalnızca teknik hizmet sunar; ödeme akışında veya bedelin aktarımında herhangi bir sorumluluğu bulunmaz.


Madde 3 – Ödeme İşlemi ve Onay

3.1. Borçlu Taraf, ödeme ekranında yer alan bilgileri doldurarak “Ödemeyi Tamamla” butonuna bastığında bu sözleşmeyi okuduğunu, anladığını ve elektronik ortamda onayladığını kabul eder.
3.2. Ödeme tutarı, açıklama ve kart bilgileri Borçlu Taraf tarafından girilir; bu bilgilerin doğruluğundan Borçlu Taraf sorumludur.
3.3. İşlem tamamlandığında sistem tarafından oluşturulan onay bilgisi elektronik ortamda kaydedilir ve taraflara iletilir.
3.4. Sistem Sağlayıcı, hatalı bilgi girişi, yetkisiz kart kullanımı, banka kaynaklı gecikmeler veya üçüncü taraf sistem arızalarından doğabilecek zararlardan sorumlu tutulamaz.


Madde 4 – Sistem Sağlayıcı’nın Statüsü ve Sorumluluk Reddi

4.1. Sistem Sağlayıcı, elektronik tahsilat arayüzü ve link gönderme altyapısı sağlayan bir yazılım sistemidir.
4.2. Sistem Sağlayıcı, 6493 sayılı Ödeme Hizmetleri ve Elektronik Para Kanunu kapsamında bir ödeme kuruluşu veya elektronik para kuruluşu değildir.
4.3. Sistem Sağlayıcı, Alacaklı Taraf ile Borçlu Taraf arasında gerçekleşen tahsilat işlemlerinin tarafı, garantörü veya sorumlusu değildir.
4.4. Sistem Sağlayıcı yalnızca teknik altyapının kesintisiz çalışmasını sağlamakla yükümlüdür.
4.5. Sistemsel aksaklık, internet kesintisi, mücbir sebep veya üçüncü taraf servis hatalarından doğan zararlardan Sistem Sağlayıcı sorumlu tutulamaz.


Madde 5 – İptal, İade ve Uyuşmazlıklar

5.1. Borçlu Taraf tarafından yapılan ödemelere ilişkin iptal veya iade talepleri doğrudan Alacaklı Taraf’a yöneltilir.
5.2. Alacaklı Taraf, iade taleplerini kendi ticari politikaları ve yürürlükteki yasal düzenlemelere göre değerlendirir.
5.3. Sistem Sağlayıcı, iade veya kısmi iade süreçlerine taraf değildir; yalnızca işlem kayıtlarını sistem loglarında saklar.
5.4. Taraflar arasındaki uyuşmazlıklar, doğrudan Alacaklı Taraf ile Borçlu Taraf arasında çözülür.


Madde 6 – Kişisel Verilerin Korunması ve Gizlilik

6.1. Sistem Sağlayıcı, işlem sırasında elde edilen kişisel verileri 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında yalnızca sistemin işleyişi, güvenliği ve yasal yükümlülüklerin yerine getirilmesi amacıyla işler.
6.2. Alacaklı Taraf, kendi müşterilerinin (Borçlu Taraf’ın) kişisel verilerini KVKK’ya uygun biçimde kullanmakla yükümlüdür.
6.3. Sistem Sağlayıcı veri işleyen sıfatındadır ve kişisel verileri üçüncü taraflarla paylaşmaz.
6.4. Sistem kayıtları (IP adresi, tarih, onay bilgileri) 5651 sayılı Kanun uyarınca yasal süre boyunca saklanır.


Madde 7 – Delil Anlaşması

7.1. Taraflar, sistem üzerinde tutulan işlem kayıtlarının, log dosyalarının, IP verilerinin ve onay bilgilerini içeren elektronik kayıtların kesin delil teşkil ettiğini kabul eder.
7.2. Bu kayıtlar, 6100 sayılı Hukuk Muhakemeleri Kanunu’nun 193. maddesi uyarınca kesin delil niteliğindedir.


Madde 8 – Uygulanacak Hukuk ve Yetkili Mahkeme

8.1. İşbu sözleşmeden doğan her türlü uyuşmazlıkta Türk Hukuku uygulanır.
8.2. Uyuşmazlıkların çözümünde, Alacaklı Taraf’ın yerleşim yerindeki Mahkemeler ve İcra Daireleri yetkilidir.


Madde 9 – Yürürlük ve Onay

9.1. Borçlu Taraf, bu sözleşmeyi elektronik ortamda onayladığı anda yürürlüğe girmiş kabul edilir.
9.2. Onay işlemi sistem tarafından loglanır ve tarih-saat damgası ile saklanır.
9.3. Elektronik onay, yazılı imza ile aynı hukuki geçerliliğe sahiptir.


Bu sözleşme elektronik ortamda onaylandığında yürürlüğe girer.
Kullanıcı, online tahsilat sistemini kullanarak bu sözleşme hükümlerini okuduğunu, anladığını ve kabul ettiğini beyan eder.


`;

export default defaultContractText;